export default __webpack_public_path__ + "static/media/laval11.8267db82.jpg";